import React from "react";

const Docs = () => {
  return <div>Docs</div>;
};

export default Docs;
